<script>
import { mapActions, mapGetters } from 'vuex'
import BookableEducatorList from './bookable-educator-list.vue'
import PreferredEducatorQueue from './preferred-educator-queue.vue'

export default {
  name: 'BookingSelectEducatorsStep',
  components: {
    BookableEducatorList,
    PreferredEducatorQueue,
  },
  props: {
    schedules: {
      type: Array,
      required: true,
    },
    selectedCertificationIds: {
      type: Array,
      default: () => [],
    },
    locationId: {
      type: Number,
      required: true,
    },
    classificationId: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isSendToANZUK: 'bookings/isSendToANZUK',
      bookableEducators: 'bookingCreate/bookableEducators',
      isLoading: 'bookingCreate/isBookableEducatorsLoading',
    }),
    needsRefresh() {
      return this.bookableEducators.needRefresh
    },
    bookingDate() {
      const bookingDates = this.schedules.map(({ dateLocal }) => dateLocal)

      return bookingDates.sort()[0] ?? null
    },
    queryContextFromProps() {
      return {
        schedules: this.schedules,
        certificationIds: this.selectedCertificationIds,
        classificationId: this.classificationId,
        locationId: this.locationId,
      }
    },
  },
  watch: {
    queryContextFromProps: {
      deep: true,
      immediate: true,
      async handler(queryContext) {
        await this.syncBookableEducatorQueryContext(queryContext)

        if (this.isActive) await this.fetchBookableEducatorsIfNeeded()
      },
    },
    async isActive(isActive) {
      if (isActive) await this.fetchBookableEducatorsIfNeeded()
    },
  },
  methods: {
    ...mapActions({
      syncBookableEducatorQueryContext:
        'bookingCreate/syncBookableEducatorQueryContext',
      fetchBookableEducators: 'bookingCreate/fetchBookableEducators',
    }),
    async fetchBookableEducatorsIfNeeded() {
      if (!this.needsRefresh) return
      if (this.isLoading) return

      await this.fetchBookableEducators()
    },
  },
}
</script>

<template>
  <v-row no-gutters class="align-stretch booking-select-educators-step">
    <v-col cols="12" md="7" class="pr-8">
      <BookableEducatorList :booking-date="bookingDate" class="fill-height" />
    </v-col>

    <v-col cols="12" md="5">
      <PreferredEducatorQueue
        class="fill-height"
        :class="{ 'opacity-50 pointer-events-none': isSendToANZUK }"
        :booking-date="bookingDate"
      />
    </v-col>
  </v-row>
</template>

<style lang="scss">
$bookable-educator-list-height: 650px;

.booking-select-educators-step {
  min-height: $bookable-educator-list-height;
}

.bookable-list {
  height: $bookable-educator-list-height;
}

.preferred-queue {
  height: $bookable-educator-list-height + 130px;
}
</style>
